/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_AnswerInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This guide does not establish a speed winner. A fair benchmark needs the same workbook, hardware, operation and measurement method. Time the task you actually repeat and check that both tools produce the same result.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本指南没有得出速度胜负结论。公平测试需要相同的文件、硬件、操作与测量方法。应计时比较实际重复执行的任务，同时确认两款工具给出一致结果。`)
};

/**
* | output |
* | --- |
* | "This guide does not establish a speed winner. A fair benchmark needs the same workbook, hardware, operation and measurement method. Time the task you actuall..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_1_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_answer(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_answer(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_1_answer as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.1.answer" }